/* eslint-disable */
/* eslint-disable react-hooks/rules-of-hooks */

import { InputLabel } from "components";
import { ReactElement } from "react";
import {
  Controller,
  ControllerFieldState,
  ControllerProps,
  ControllerRenderProps,
  FieldPath,
  FieldValues,
  UseFormStateReturn,
  useFormContext,
} from "react-hook-form";

export const FormController = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  children,
  label,
  required,
}: Omit<ControllerProps<TFieldValues, TName>, "control" | "render"> & {
  children: ({
    field,
    fieldState,
    formState,
  }: {
    field: ControllerRenderProps<TFieldValues, TName>;
    fieldState: ControllerFieldState;
    formState: UseFormStateReturn<TFieldValues>;
  }) => ReactElement<any>;
  label: string;
  required?: boolean;
}) => {
  const { control } = useFormContext<TFieldValues>();
  return (
    <>
      <InputLabel
        sx={{
          marginBottom: "6px",
        }}
        required={required}
      >
        {label}
      </InputLabel>
      <Controller name={name} control={control} render={children} />
    </>
  );
};
